;(function () {
  'use strict'

  angular.module('deskfy.core').controller('TableColumnRowDateController', tableColumnRowDateController)

  /* @ngInject */
  function tableColumnRowDateController ($rootScope, $scope, $translate, Utils) {
    $scope.getSinceDateText = function (date) {
      const defaultLocale = 'PT-BR'
      const sinceDate = Utils.getTimeSince(date, $rootScope?.oUser?.locale || defaultLocale)
      return sinceDate
    }
  }
})()
